import { api } from "./../../config/api";

const basePath = "webservice";

/**
 * Cities
 *
 * @param {Object} options
 * @param {string} [options.cancelToken]
 * @param {string} [options.search]
 *
 * @returns {Promise<T>}
 */
export const getCities = (options) => {
	const options_default = {};

	// Merge config
	options = Object.assign({}, options_default, options);

	let params    = [];
	let params_qs = "";

	if( options.hasOwnProperty("search") )
	{
		params.push(`search=${options.search}`);
	}

	if( params.length )
	{
		params_qs = `?${params.join("&")}`;
	}

	let data = {};

	if( options.hasOwnProperty("cancelToken") )
	{
		data.cancelToken = options.cancelToken;
	}

	return api.get(`${basePath}/cities${params_qs}`, data);
};

/**
 * States
 *
 * @param {Object} options
 * @param {string} [options.cancelToken]
 * @param {string} [options.search]
 *
 * @returns {Promise<T>}
 */
export const getStates = (options) => {
	const options_default = {};

	// Merge config
	options = Object.assign({}, options_default, options);

	let params    = [];
	let params_qs = "";

	if( options.hasOwnProperty("search") )
	{
		params.push(`search=${options.search}`);
	}

	if( params.length )
	{
		params_qs = `?${params.join("&")}`;
	}

	let data = {};

	if( options.hasOwnProperty("cancelToken") )
	{
		data.cancelToken = options.cancelToken;
	}

	return api.get(`${basePath}/states${params_qs}`, data);
};

/**
 * Recommendations items
 *
 * @returns {Promise<T>}
 */
export const getRecommendationsItems = () => {
	return api.get(`${basePath}/recommendations/items`);
};
